import { Component, OnInit, ComponentFactoryResolver, Inject } from '@angular/core';
import { MemberService } from '../../../services/member.service';
import { Member } from '../../../models/member';
import { Category } from 'src/app/models/category';
import { Subscription } from 'rxjs';
import { CategoryService } from 'src/app/services/category.service';
import { OrderedService } from 'src/app/services/ordered.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-ordered-file-dialog',
  templateUrl: './ordered-file-dialog.component.html',
  styleUrls: ['./ordered-file-dialog.component.scss']
})
export class OrderedFileDialogComponent implements OnInit {

  public orderedList: any[] = [];
  public errors: any[] = [];
  private fileReaded: any;
  public spinner: boolean = false;

  public subscriptionAllOrdered: Subscription;

  public allMembers: Member[] = [];
  public subscriptionAllMembers: Subscription;

  public allCategory: Category[] = [];
  public subscriptionAllCategory: Subscription;

  constructor(
    private _orderedService: OrderedService,
    private _memberService: MemberService,
    private _categoryService: CategoryService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this._orderedService.select();

  }

  ngOnInit() {
    this.loadAllMembers();
    this.loadAllCategory();
  }

  ngOnDestroy() {
    if (this.subscriptionAllOrdered)
      this.subscriptionAllOrdered.unsubscribe();
  }

  readCSVFile(fileInput: any) {
    //read file from input
    this.errors = [];

    this.fileReaded = fileInput.target.files[0];

    let reader: FileReader = new FileReader();
    reader.readAsText(this.fileReaded);

    reader.onload = (e) => {
      let csv: any = reader.result;
      let allTextLines = csv.split(/\r\n|\n/);
      let headers = allTextLines[0].split(';');
      let lines = [];

      for (var i = 1; i < allTextLines.length; i++) {
        let data = allTextLines[i].split(';');

        if (data[0] != "") {

          let tarr = []
          for (let j = 0; j < headers.length; j++) {
            tarr.push(data[j]);
          }

          lines.push(tarr);
        }
      }

      for (let i = 0; i < lines.length; i++) {
        let order: any = {}

        //produto selecionado
        order.product_id = this.data.id 
        order.product_name = this.data.name

        //  return code = all ordered is ok
        order.returnCode = "00"

        order.member_cpf = this.validateCpf(lines[i][11]);// cpf

        let member = this.allMembers.find((e) => {
          return e.cpf == order.member_cpf
        })

        if (!member) {
          
          console.log("não encontrado: " + lines[i][11])

        } else {

          order.member_name = lines[i][1];
          order.member_name = this.firstUpper(order.member_name).trim()
          order.member_id = member.id;

          order.category_name = lines[i][2];
        //  order.category_id = lines[i][3];

          order.payment_type = lines[i][3];

          order.card_installments = Number(lines[i][6]);

          if (order.payment_type == "CreditCard") { // visa, master, amex ...
            order.card_brand = lines[i][4];

            if (order.card_installments == 1) {
              order.tax = 0.037 // cartao vista
            } else {
              order.tax = 0.047  // cartao prazo
            }
          } else {
            order.tax = 0.035 // boleto itau
          }

          order.Tid = lines[i][5]; //tid

          order.date = lines[i][7]; // data

          let parts = order.date.split("/")
          let dt = parts[1] + "/" + parts[0] + "/" + parts[2]

          order.date = new Date(dt)
          order.total = this.validateCurrency(lines[i][8]); // total
          order.value = order.total
          order.member_debit = 0;
          order.total_minus_tax = this.validateCurrency(lines[i][9]); // total_minus_tax

          order.origin = lines[i][10]; // web, ios, android

          // order.city = lines[i][12];  // cidade
          // order.estado = lines[i][13];  // estado

          order.member_cellPhone = this.validateCelular(lines[i][14]); // celular
          order.member_email = lines[i][15]; // email

          if (this.validateOrdered(order, i + 2)) {
            this.orderedList.push(order)
          }

        }

      }

    }
  }

  firstUpper(text) {

    var textRet = ""

    if (text) {

      // separa entre espaços 
      let parts = text.split(" ")
      // formata a primeira letra de cada parte maiúscula        
      parts.forEach(function (part) {

        if (part.toUpperCase() == "DA" || part.toUpperCase() == "DE" || part.toUpperCase() == "DI" || part.toUpperCase() == "DO" || part.toUpperCase() == "DU" || part.toUpperCase() == "AS" || part.toUpperCase() == "E" || part.toUpperCase() == "A" || part.toUpperCase() == "DAS" || part.toUpperCase() == "DOS" || part.toUpperCase() == "ÀS") {
          textRet += part.toLowerCase() + " "
        }
        else {
          var firstLetter = part.substring(0, 1)
          var otherLetters = part.substring(1, part.length)
          textRet += firstLetter.toUpperCase() + otherLetters.toLowerCase() + " "
        }
      })
    }
    return textRet
  }


  validateOrdered(order, position) {

    let valid: boolean = true;

    if (!order.member_cpf || order.member_cpf.length == 0) {
      this.errors.push(position + " - " + order.name + " - faltou o cpf")
      valid = false;
    } else if (!this.memberExist(order)) {
      this.errors.push(position + " - " + order.member_name + " Não etá cadastrado (sem cpf)")// + entity.member_cpf + " está em uso.")
      valid = false;
    }

    let category = this.allCategory.find((e)=>{
      return e.name.toUpperCase() == order.category_name.toUpperCase()
    })

    if(category){
      console.log("category.name: "  + category.name)
    } else {
      this.errors.push(position + " - " + order.category_name + " - categoria não encontrada")
      valid = false
    }


    return valid;
  }

  validateCelular(celularString) {
    let celular = celularString
      .replace("(", "")
      .replace(")", "")
      .replace("-", "")
      .replace(" ", "")
    return celular.trim()
  }

  validateCpf(cpfString) {
    let cpf: any = cpfString
      .replace("-", "")
      .replace(".", "")
      .replace(".", "")
    return cpf
  }

  validateCurrency(valueString: string): number {

    let value: string = valueString
      .replace("R$", "")
      .replace(".", "")
      .replace(",", ".")
    // console.log(Number(value))
    return Number(value)
  }


  uploadCSVFile() {

    console.log("uploadCSVFile:  " + JSON.stringify(this.orderedList))

    if (this.orderedList.length > 0) {
   //   this._orderedService.updateCsvOrdered(this.orderedList);
    }

  }

  loadAllMembers(): any {

    this.subscriptionAllMembers = this._memberService.select()
      .subscribe((result) => {

        this.allMembers = result.map(item => {
          let entity = new Member();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.cpf = item.payload.doc.data().cpf;
          return entity;
        });

      },
        (error) => {
          console.log(JSON.stringify(error))
        })

  }

  memberExist(member: any) {

    if (this.allMembers.length > 0) {

      let exist = this.allMembers.find((e) => {
        return e.cpf == member.member_cpf
      })

      if (exist) {
        return true
      } else {
        return false
      }

    } else {
      return false
    }
  }


  loadAllCategory(): any {

    this.subscriptionAllCategory = this._categoryService.select()
      .subscribe((result) => {

        this.allCategory = result.map(item => {
          let entity = new Category();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          return entity;
        });

      },
        (error) => {
          console.log(JSON.stringify(error))
        })

  }




}